import { GameFont } from "by/gamefactory/cityversetycoon/scenes/common/GameFont";
import { Container, Text, TextStyle } from "pixi.js";

export class YouNoMoreOwnerTextContainer extends Container {
    private static readonly IT_SEEMS_TEXT = "IT SEEMS YOU NO LONGER";
    private static readonly OWN_TEXT = "OWN A";
    private static readonly LAST_BUILDING_TEXT = "BUILDING";
    private static readonly IN_THE_GAME_TEXT = "IN THE GAME.";
    private static readonly TO_CONTINUE_TEXT = "TO CONTINUE PLAYING,";
    private static readonly YOU_MUST_TEXT = "YOU MUST OWN AT LEAST ONE BUILDING.";
    private static readonly PLEASE_VISIT_TEXT = "PLEASE VISIT THE IN-GAME MARKETPLACE";
    private static readonly TO_PURCHASE_TEXT = "TO PURCHASE YOUR";
    private static readonly NEXT_BUILDING_TEXT = "NEXT BUILDING,";
    private static readonly CONNEXT_TEXT = "OR YOU CAN CONNECT YOUR";
    private static readonly EXTERNAL_WALLET_TEXT = "EXTERNAL WALLET WHICH HOLDS";
    private static readonly BUILDING_NFT_TEXT = "A BUILDING NFT";

    private itAppearsText: Text;
    private ownText: Text;
    private lastBuildingText: Text;
    private inTheGameText: Text;
    private toContinueText: Text;
    private youMustText: Text;
    private pleaseVisitText: Text;
    private toPurchaseText: Text;
    private nextBuildingText: Text;
    private connectText: Text;
    private externalWalletText: Text;
    private buildingNftText: Text;

    public constructor() {
        super();
        this.build();
        this.layout();
    }

    private build(): void {
        this.itAppearsText = new Text(YouNoMoreOwnerTextContainer.IT_SEEMS_TEXT, new MainTextStyle());
        this.itAppearsText.style.fontSize = 64.67;
        this.ownText = new Text(YouNoMoreOwnerTextContainer.OWN_TEXT, new MainTextStyle());
        this.ownText.style.fontSize = 64.67;
        this.lastBuildingText = new Text(YouNoMoreOwnerTextContainer.LAST_BUILDING_TEXT, new MainTextStyle());
        this.lastBuildingText.style.fontSize = 64.67;
        this.lastBuildingText.style.fill = ["#ff228d", "#ff02bd"];
        this.inTheGameText = new Text(YouNoMoreOwnerTextContainer.IN_THE_GAME_TEXT, new MainTextStyle());
        this.inTheGameText.style.fontSize = 64.67;
        this.toContinueText = new Text(YouNoMoreOwnerTextContainer.TO_CONTINUE_TEXT, new MainTextStyle());
        this.toContinueText.style.fontSize = 86;
        this.youMustText = new Text(YouNoMoreOwnerTextContainer.YOU_MUST_TEXT, new MainTextStyle());
        this.youMustText.style.fontSize = 48;
        this.pleaseVisitText = new Text(YouNoMoreOwnerTextContainer.PLEASE_VISIT_TEXT, new MainTextStyle());
        this.pleaseVisitText.style.fontSize = 46;
        this.toPurchaseText = new Text(YouNoMoreOwnerTextContainer.TO_PURCHASE_TEXT, new MainTextStyle());
        this.toPurchaseText.style.fontSize = 54;
        this.nextBuildingText = new Text(YouNoMoreOwnerTextContainer.NEXT_BUILDING_TEXT, new MainTextStyle());
        this.nextBuildingText.style.fontSize = 54;
        this.nextBuildingText.style.fill = ["#6fea0d", "#62e70e"];
        this.connectText = new Text(YouNoMoreOwnerTextContainer.CONNEXT_TEXT, new MainTextStyle());
        this.connectText.style.fontSize = 70;
        this.externalWalletText = new Text(YouNoMoreOwnerTextContainer.EXTERNAL_WALLET_TEXT, new MainTextStyle());
        this.externalWalletText.style.fontSize = 58;
        this.buildingNftText = new Text(YouNoMoreOwnerTextContainer.BUILDING_NFT_TEXT, new MainTextStyle());
        this.buildingNftText.style.fontSize = 124;
        this.buildingNftText.style.fill = ["#AAFD09", "#16CF15"];

        this.addChild(
            this.itAppearsText,
            this.ownText,
            this.lastBuildingText,
            this.inTheGameText,
            this.toContinueText,
            this.youMustText,
            this.pleaseVisitText,
            this.toPurchaseText,
            this.nextBuildingText,
            this.connectText,
            this.externalWalletText,
            this.buildingNftText
        );
    }

    private layout(): void {
        this.itAppearsText.position.set(32, -4);
        this.ownText.position.set(-13, 57);
        this.lastBuildingText.position.set(120, 57);
        this.inTheGameText.position.set(309, 57);
        this.toContinueText.position.set(-14, 151);
        this.youMustText.position.set(-10, 225);
        this.pleaseVisitText.position.set(-10, 273);
        this.toPurchaseText.position.set(-10, 316);
        this.nextBuildingText.position.set(311, 316);
        this.connectText.position.set(-10, 367);
        this.externalWalletText.position.set(-10, 432);
        this.buildingNftText.position.set(-11, 485);
    }
}

class MainTextStyle extends TextStyle {
    public constructor() {
        super({
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 49,
            fill: 'FFFFFF',
            trim: true,
            dropShadow: true,
            dropShadowAlpha: 0.3,
            dropShadowAngle: 0.7,
            dropShadowBlur: 5,
            dropShadowColor: '0D0606',
            dropShadowDistance: 3
        });
    }
}
